// use this to confirmed that you want to delete a prompt, either published or unpublished
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import withRouter from '../../utils/withRouter';
import { deletePrompt, closeModal } from '../../actions';
import CircularLoadingButton from '../commoncomponents/CircularLoadingButton';
import {
  deletePromptType,
  closeModalType,
  promptIDType,
  promptTitleType,
  loadingType,
  classesType,
  historyType
} from '../../types';

const styles = {
  wrapper: {
    position: 'relative'
  },
  dialogActions: {
    padding: '1rem'
  }
};

class DeletePromptModal extends Component {
  handleDelete = async () => {
    const { promptID, promptTitle } = this.props;
    await this.props.deletePrompt(promptID, promptTitle);
    this.props.closeModal();
    // note that after sucessfully deleting the prompt, we go back to our list of prompts on profile page
    this.props.history.push('/profile/Prompts');
  };

  render() {
    const { promptTitle, loading, classes } = this.props;
    return (
      <Dialog
        open
        onClose={this.props.closeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="form-dialog-title">Delete Prompt</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`Do you want to permantly delete ${promptTitle}?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            onClick={this.props.closeModal}
            // color="primary"
            // variant="contained"
          >
            Cancel
          </Button>
          <div className={classes.wrapper}>
            <Button
              onClick={this.handleDelete}
              color="primary"
              variant="contained"
            >
              Delete
            </Button>
            {loading && <CircularLoadingButton />}
          </div>
        </DialogActions>
      </Dialog>
    );
  }
}

DeletePromptModal.propTypes = {
  deletePrompt: deletePromptType.isRequired,
  closeModal: closeModalType.isRequired,
  promptID: promptIDType.isRequired,
  promptTitle: promptTitleType.isRequired,
  loading: loadingType.isRequired,
  classes: classesType.isRequired,
  history: historyType.isRequired
};

const mapStateToProps = ({ async: { loading } }) => {
  return { loading };
};

const actions = { deletePrompt, closeModal };

const enhance = compose(
  connect(mapStateToProps, actions),
  withStyles(styles),
  withRouter
);

export default enhance(DeletePromptModal);
